import { render, staticRenderFns } from "./RewardChoice.vue?vue&type=template&id=36b95507&"
import script from "./RewardChoice.vue?vue&type=script&lang=js&"
export * from "./RewardChoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-user-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36b95507')) {
      api.createRecord('36b95507', component.options)
    } else {
      api.reload('36b95507', component.options)
    }
    module.hot.accept("./RewardChoice.vue?vue&type=template&id=36b95507&", function () {
      api.rerender('36b95507', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/survey/components/RewardChoice.vue"
export default component.exports